import React, { useState, useEffect } from 'react';

const InstructionPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    const dontShow = sessionStorage.getItem('dontShowPopup');
    if (dontShow !== 'true') {
      setShowPopup(true);
    }
  }, []);

  const handleClose = () => {
    if (dontShowAgain) {
      sessionStorage.setItem('dontShowPopup', 'true');
    }
    setShowPopup(false);
  };

  if (!showPopup) {
    return null;
  }

  return (
    <div className="instruction-popup">
      <div className="instruction-popup-content">
        <div className="instruction-popup-header">
          <h2>Instructions</h2>
          <button className="close-button" onClick={handleClose}>Close</button>
        </div>
        <div className='instruction-contents'>
          <div className='instruction-contents-title'>
            Welcome! <br></br>Let's begin planning for Indego's bike share expansion plan.
          </div> 
          <div className='instruction-contents-title'>
            Step 1
          </div> 
          <div className='instruction-contents-small'>
            Zoom in and out of Philadelphia's Indego service area by scrolling with your mouse.<br></br> Feel free to hover over existing bike stations for more information.
          </div> 
          <div className='instruction-contents-title'>
            Step 2
          </div> 
          <div className='instruction-contents-small'>
            Explore Philadelphia's current bike share ridership and population distribution<br></br> by using the buttons on the left hand side.
          </div> 
          <div className='instruction-contents-title'>
            Step 3
          </div> 
          <div className='instruction-contents-small'>
            Click anywhere on the map to add new stations. Please note, ridership predictions are limited to one new station per grid cell. Don't worry if you make a mistake, you can make edits using the reset and delete tools on the right hand side!
          </div> 
          <div className='instruction-contents-title'>
            Step 4
          </div> 
          <div className='instruction-contents-small'>
            Watch how Indego's performance metrics change as you add and delete new stations!
          </div>
          <div className='instruction-contents-title'>
            Step 5
          </div> 
          <div className='instruction-contents-small'>
            Feel free to save any new configuration of Indego bike share stations by using the download button on the bottom right corner. <br></br> To upload them back into the map at a later point, just click on the import button!
          </div> 
          <div className='instruction-contents-title'>
            Now, go start planning!
          </div> 

        </div>

        <label style={{ paddingTop: "20px", fontSize: "0.8em" }}>
          <input
            type="checkbox"
            checked={dontShowAgain}
            onChange={() => setDontShowAgain(!dontShowAgain)}
          />
          Don't show this again
        </label>
      </div>
    </div>
  );
};

export default InstructionPopup;
